import React from 'react';
import BaseIcon, { IconProps } from './Base.icon';

const BriefcaseIcon = ({ width, height }: IconProps) => {
  return (
    <BaseIcon width={width} height={height} viewBox="0 0 16 16">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15 3.97998H12V1.97998C12 1.42998 11.55 0.97998 11 0.97998H5C4.45 0.97998 4 1.42998 4 1.97998V3.97998H1C0.45 3.97998 0 4.42998 0 4.97998V8.97998H3V7.97998H5V8.97998H11V7.97998H13V8.97998H16V4.97998C16 4.42998 15.55 3.97998 15 3.97998ZM10 3.97996H6V2.97996H10V3.97996ZM13 10.98H11V9.98H5V10.98H3V9.98H0V13.98C0 14.53 0.45 14.98 1 14.98H15C15.55 14.98 16 14.53 16 13.98V9.98H13V10.98Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
};

export default BriefcaseIcon;
